var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:{
    [_vm.buttonClass]: _vm.buttonClass,
    'current-event': _vm.currentEvent,
  },attrs:{"to":_vm.path,"title":_vm.title}},[(_vm.isPaid)?_c('credit-card',{staticClass:"mr-2 event-button__card"}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }